import * as Yup from 'yup';

export const validationSchemaFormSalom = Yup.object({
  contractNumber: Yup.string().required('Поле обязательно для заполнения'),
});
